import cx from 'classnames'
import { FC } from 'react'
import { ActionButtonProps } from 'src/components/ActionButton'
import { BlockTitleProps } from 'src/components/BlockTitle'
import ParallaxShape from 'src/components/ParallaxShape'
import { PictureProps } from 'src/components/Picture'
import { RichTextProps } from 'src/components/RichText'
import { motionSlide } from 'src/hooks/useAppear'
import { colors } from 'src/theme'

import * as SC from './styled'

export type SinglePushProps = {
  className?: string
  blockTitleProps?: BlockTitleProps
  color?: string
  pictureProps?: PictureProps
  richTextProps?: RichTextProps
  actionButtonProps?: ActionButtonProps
}

const SinglePush: FC<SinglePushProps> = ({
  className,
  blockTitleProps,
  pictureProps,
  richTextProps,
  color = colors.yellowPale,
  actionButtonProps,
}) => {
  const { motionProps } = motionSlide({})

  return (
    <SC.Container className={cx('SinglePush', className)}>
      {blockTitleProps && <SC._BlockTitle {...blockTitleProps} />}
      <SC.Wrapper {...motionProps}>
        {pictureProps && <SC._Picture {...pictureProps} />}
        <SC.Deco aria-hidden>
          <SC.Shape>
            <ParallaxShape color={color} />
          </SC.Shape>
        </SC.Deco>
        <SC.Content>
          {richTextProps && <SC._RichText {...richTextProps} />}
          {actionButtonProps && <SC._ActionButton {...actionButtonProps} />}
        </SC.Content>
      </SC.Wrapper>
    </SC.Container>
  )
}

export default SinglePush
